// extracted by mini-css-extract-plugin
export var dividerLine = "_81-3";
export var itemImage = "_81-9";
export var lightDivider = "_81-4";
export var modalContent = "_81-5";
export var modalContentCompact = "_81-6";
export var productCard = "_81-a";
export var productImage = "_81-b";
export var productImageCompact = "_81-7";
export var productImagePlaceholder = "_81-c";
export var productImagePlaceholderCompact = "_81-8";
export var progressBarBackground = "_81-1";
export var progressBarContainer = "_81-0";
export var progressBarFill = "_81-2";